import React from 'react';

import BeltItem from './BeltItem'

import Header from './../Header/Header'
import Footer from './../Footer/Footer'

import EigthKyu from '../../assets/images/belts/white.svg'
import SeventhKyu from '../../assets/images/belts/yellow.svg'
import SixthKyu from '../../assets/images/belts/orange.svg'
import FifthKyu from '../../assets/images/belts/green.svg'
import FourthKyu from '../../assets/images/belts/purple.svg'
import ThirdKyu from '../../assets/images/belts/light-blue.svg'
import SecondKyu from '../../assets/images/belts/dark-blue.svg'
import FirstKyu from '../../assets/images/belts/brown.svg'

// belts stateless component
const BeltList = () =>
	<div>
		<Header />
		<section class="section">
			<div class="container">
				<h1 class="title">Grados y Cinturones</h1>
				<p class="has-text-justified">
					Los cinturones en Jiu Jitsu empiezan con los grados "Kyu" (grado alumno) y después "Dan" (grado maestro).
					Hay 8 cinturones Kyu en Jiu Jitsu y para pasar de uno al próximo grado se necesita completar un examen.
				</p>

				<BeltItem title = "8° Kyu - Cinturón Blanco" image = {EigthKyu}>
					<p>Principiante, cuando empiezas hacer Jiu Jitsu tienes el grado 8° Kyu.</p>
				</BeltItem>

				<BeltItem title = "7° Kyu - Cinturón Amarillo" image = {SeventhKyu}>
					<p>Caídas básicas, palancas de brazo y de muñeca, 4 lances y defensas básicas contra agarres y golpes, defensas contra botella, retenciones en el suelo, Kata (forma) de las partes peligrosas (solamente adultos).</p>
					<p>Al pasar el examen te serán otorgados 0, 1, 2 o 3 "mons" rojos o anaranjadas que son unas cintas que van en tu cinturón. Si pasas con 0 mons significa que pasaste el examen con bueno, con 1 mon muy bueno, con 2 mons excelente y con 3 mons excepcional.</p>
				</BeltItem>

				<BeltItem title = "6° Kyu - Cinturón Anaranjado" image = {SixthKyu}>
					<p>Más caídas avanzadas, 5 lances más, 3 palancas de brazo más, 3 retenciones más, defensas contra agarres de cuerpo, defensas contra un palo.</p>
					<p>Como el examen del 7° Kyu, al pasar tu examen del 6° Kyu puedes pasar con 0, 1, 2 o 3 mons verdes.</p>
				</BeltItem>

				<BeltItem title = "5° Kyu - Cinturón Verde" image = {FifthKyu}>
					<p>6 lances más, inmovilizaciones en el suelo, 3 palancas de muñeca más, 3 retenciones más, defensas contra cuchillo y botella rota.</p>
					<p>A partir del examen para 5° Kyu no hay mons, sólo se puede aprobar o fallar el examen.</p>
				</BeltItem>

				<BeltItem title = "4° Kyu - Cinturón Violeta" image = {FourthKyu}>
					<p>10 lances más, 3 retenciones más, defensas contra bokken (espada de madera), cadena y ataques múltiples, Empi Kata (Kata de codo), conocimiento del Nage no Kata. Los candidatos además necesitan aprobar su cualificación de instructor asistente.</p>
				</BeltItem>

				<BeltItem title = "3° Kyu - Cinturón Celeste" image = {ThirdKyu}>
					<p>Caídas avanzadas sin apoyo, 8 lances más, palancas de cabeza, contras de todos palancas de brazo y de muñeca, estrangulamientos y contras, defensas contra atacantes múltiples con armas, Nage no Kata 6 lances del primer fase. Los candidatos además necesitan aprobar su cualificación de instructor.</p>
				</BeltItem>

				<BeltItem title = "2° Kyu - Cinturón Azul" image = {SecondKyu}>
					<p>11 lances más, palancas de pierna y contras, contras de palancas de cabeza, defensas usando un bastón, defensas contra dos atacantes con diferentes armas. Conocimiento de primeros auxilios.</p>
				</BeltItem>

				<BeltItem title = "1° Kyu - Cinturón Marrón" image = {FirstKyu}>
					<p>Caídas básicas en el suelo (sin tatame), 7 lances más, defensas contra dos atacantes con cualquier arma no afilado, defensas de cerca distancia, defensas contra estilos de boxeo y kickboxing. Además los candidatos deben aprobar su cualificación de instructor de club.</p>
					<p>Al pasar a 1° Kyu se puede enseñar Shorinji Kan Jiu Jitsu.</p>
				</BeltItem>
			</div>
		</section>
		<Footer />
	</div>

export default BeltList;



// WEBPACK FOOTER //
// ./src/components/About/Belts.js